import React from 'react';
import { styled } from 'styled-components';
import { MEDIA_WIDTHS } from '../theme/Theme';
import { Image } from 'antd';
import Twitter from '../assets/landing/twitter.svg';
import Telegram from '../assets/landing/telegram.svg';
import Discord from '../assets/landing/discord.svg';

const Wrapper = styled.div`
    width: 100%;
    background: white;
    .body {
        margin: auto;
        height: 100%;
        width: 100%;
        padding: 40px 20px;
        max-width: 1440px;
        .content {
            flex: 1;
            width: 100%;
            .large-title {
                font-family: 'Karmatic Arcade';
                font-style: normal;
                font-weight: 400;
                font-size: 40px;
                line-height: 56px;
                display: flex;
                justify-content: center;
                align-items: center;
                letter-spacing: 2px;
                color: #000000;
                margin-bottom: 60px;
            }
            .title {
                font-family: 'Joystix';
                font-style: normal;
                font-weight: 400;
                font-size: 22px;
                line-height: 34px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #ea34b0;
            }
            .sub-title {
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                text-align: center;
            }
            .desc {
                font-family: 'Joystix';
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 32px;
                text-align: center;
                color: #585858;
                margin: 0 auto;
            }
            .social-box {
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
            .width-70 {
                width: 70%;
            }
        }
    }

    @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        .body {
        }
    }
`;

const SocialBox = styled.div`
    width: 48px;
    height: 48px;
    border: 1px solid #ea34b0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        cursor: pointer;
    }
`;

const SpaceWidth = styled.div`
    width: 20px;
`;
const SpaceHeight = styled.div`
    height: 20px;
`;

const BpunksContact = () => {
    return (
        <Wrapper>
            <div className="body">
                <div className="content">
                    <p className="large-title">Socical</p>
                    <p className="title">BPunks</p>
                    <SpaceHeight />
                    <div className="social-box">
                        <SocialBox onClick={() => window.open('https://twitter.com/bpunksofficial', '_blank')}>
                            <Image preview={false} src={Twitter} />
                        </SocialBox>
                        <SpaceWidth />
                        <SocialBox onClick={() => window.open('https://discord.gg/raSSjJwVT3', '_blank')}>
                            <Image preview={false} src={Discord} />
                        </SocialBox>
                    </div>
                    <SpaceHeight />
                    <p className="desc width-70">Copyright © 2023.</p>
                    <SpaceHeight />
                    <p className="desc width-70">BPunks is in no way affiliated with Larva Labs and/or CryptoPunks.</p>
                </div>
            </div>
        </Wrapper>
    );
};

export default BpunksContact;
